import styled from 'styled-components';

export const StyledBatchPlatformsLinkWithLocation = styled.div`
    padding: 2rem;
`;
